import React, { useEffect, useState } from "react";
import { getHomeUserList } from "../../../Services/getHomeUserList";
import SearchYellowIcon from '../../../../../images/home-landing-page/search-yellow-icon.png';
import EmptyProfileImage from '../../../../../images/navbar/empty-profile-image.png'
import { jwtDecode } from "jwt-decode";
import Placeholder from 'react-bootstrap/Placeholder';
import { formatChatTimestamp } from '../../../../../utils/chatFormatters';

function Conversation({ setActiveConversation, unreadMessages, setBusiness })
{

    // State to hold the search input value
    const [searchTerm, setSearchTerm] = useState("");
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeConversationId, setActiveConversationId] = useState(null);
    const [selectedQuoteId, setSelectedQuoteId] = useState(null);
    const filteredConversations = conversations.filter((conversation) =>
        conversation.userName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const [selectedUserId, setSelectedUserId] = useState(null);

    const unreadActiveMessages = async () =>
    {
        try
        {
            if (unreadMessages !== null)
            {
                unreadMessages.num = 0;
            }

        }
        catch (e)
        {
            console.log(e);
        }
    }

    useEffect(() =>
    {
        const getConversations = async () =>
        {
            try
            {
                setLoading(true);

                const token = localStorage.getItem('token');
                if (token)
                {
                    const decodedToken = jwtDecode(token);
                    const homeUserId = decodedToken.nameid;
                    const conversationsData = await getHomeUserList(homeUserId);

                    const selectedId = sessionStorage.getItem('chatUserId');
                    if (selectedId)
                    {
                        const parsedSelectedId = parseInt(selectedId);
                        setSelectedUserId(parsedSelectedId);

                        const selectedUserConversation = conversationsData.find(conversation => conversation.userId === parsedSelectedId);
                        if (selectedUserConversation)
                        {
                            const filteredConversations = conversationsData.filter(conversation => conversation.userId !== parsedSelectedId);
                            setConversations([selectedUserConversation, ...filteredConversations]);
                        } else
                        {
                            setConversations(conversationsData);
                        }
                    } else
                    {
                        setConversations(conversationsData);
                    }
                }
            } catch (error)
            {
                console.error("Error fetching conversations:", error);
                setError("Failed to load conversation list.");
            } finally
            {
                setLoading(false);
            }
        };
        getConversations();
    }, []);


    // if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;


    return (

            <div className="conversation-wrapper" >
                <h4>Messages</h4>
                <div class="chat-search">
                    <input
                        type="text"
                        placeholder="Enter keyword"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <img src={SearchYellowIcon} />
                </div>

                <div className={`chat-persons-list ${loading ? "skelton-active" : ""}`}>
                    {loading ? (
                        Array.from({ length: 5 }).map((_, index) => (
                            <div key={index} className="chat-person-box placeholder-box">
                                <figure>
                                    <Placeholder as="div" animation="glow">
                                        <Placeholder className="rounded-circle" style={{ width: '61px', height: '61px' }} />
                                    </Placeholder>
                                </figure>

                                <div className="chat-person-detail">
                                    <div className="chat-person-name-date">
                                        <Placeholder as="p" animation="glow">
                                            <Placeholder xs={6} />
                                        </Placeholder>
                                        <Placeholder as="span" animation="glow">
                                            <Placeholder xs={4} />
                                        </Placeholder>
                                    </div>
                                    <Placeholder as="p" animation="glow">
                                        <Placeholder xs={8} />
                                    </Placeholder>
                                </div>
                            </div>
                        ))
                    ) : (
                        filteredConversations.map((conversation, index) => (
                            <React.Fragment key={index}>
                                <div
                                  onClick={() => {
                                    unreadActiveMessages();
                                    setActiveConversation(conversation);
                                    setActiveConversationId(conversation?.userId);
                                    setBusiness(conversation);
                                    setSelectedUserId(null);
                                    setSelectedQuoteId(conversation.quoteId);
                                    sessionStorage.removeItem('chatUserId');
                                
                                    // Update the conversation's unreadMessages to 0
                                    setConversations(prevConversations =>
                                        prevConversations.map(conv =>
                                            conv.conversationId === conversation.conversationId
                                                ? { ...conv, unreadMessages: 0 } // Mark as read
                                                : conv // Keep other conversations unchanged
                                        )
                                    );
                                }}
                                
                                    className={`chat-person-box ${(selectedUserId === conversation.userId || activeConversationId === conversation.userId) && (conversation?.quoteId == selectedQuoteId) ? "active" : ""}`}
                                >
                                    <figure>
                                        <img
                                            src={(conversation?.userProfileUrl == null || conversation?.userProfileUrl == "") ? EmptyProfileImage : conversation?.userProfileUrl}
                                            alt={conversation.userName}
                                        />
                                    </figure>

                                    <div className="chat-person-detail">
                                        <div className="chat-person-name-date">
                                            <p>{conversation?.userName} </p> <span>{formatChatTimestamp(conversation?.updatedDate) || "Just now"}</span>
                                        </div>
                                        <p className="chat-hint">
                                            <span className="chat-hint-text">{conversation?.lastMessage || ""}</span>
                                            {conversation?.isLastMessageMine ? (
                                                <span className={`read-receipt ${conversation?.lastMessageStatus === 'read' ? 'read' : 'sent'}`}>
                                                    {conversation?.lastMessageStatus === 'read' ? '✓✓' : '✓'}
                                                </span>
                                            ) : (conversation?.unreadMessages !== 0 ) ? (
                                                <span className="incoming-msg">{conversation?.unreadMessages}</span>
                                            ) : (unreadMessages?.num !== 0 || unreadMessages != null) && unreadMessages?.conversationId === conversation?.conversationId ? (
                                                <span className={`${unreadMessages?.num != 0 ? "incoming-msg" : ""}`}>{unreadMessages?.num != 0 ? unreadMessages?.num : ""}</span>
                                            ) : ""}
                                        </p>
                                    </div>
                                </div>
                            </React.Fragment>
                        ))
                    )
                    }
                </div>


            </div>

    );
}

export default Conversation;
